import { RoomDetailsModal } from 'bf-library';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, intlShape } from 'react-intl';

import { imageShape, marketingShape } from '../../constants/PropTypes';

function CardImage(props) {
    const { className, title, images, marketing, code, intl } = props;

    const mainImage = images && images.length > 0 && images[0].url
        ? images[0]
        : null;

    return (
        <div className={`kbe-card-image-wrapper ${className}`}>
            <RoomDetailsModal roomInfo={{ code, title, images, mainImage }} intl={intl} />
            {
                marketing
                    ? <div className={`kbe-marketing-label ${marketing.type}`}>
                        {marketing.content}
                    </div>
                    : null
            }
        </div>
    );
}

CardImage.defaultProps = {
    className: '',
    marketing: null,
    title: '',
    images: [],
};

CardImage.propTypes = {
    intl: intlShape.isRequired,
    className: PropTypes.string,
    marketing: PropTypes.shape(marketingShape),
    title: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.shape(imageShape)),
    code: PropTypes.string,
};

export default injectIntl(CardImage);

// i18nLabel[bf.imagePreview]
// i18nLabel[bf.displayImagePreview]
// i18nLabel[bf.defaultImage]
// i18nLabel[bf.openImageGallery]
